import React from 'react';
import { Stack, Typography } from '@mui/material';

const PageHeader = () => (
  <Stack spacing={1.25} sx={{ mb: 0.5 }}>
    <Typography
      variant="h4"
      sx={{
        fontWeight: 700,
        lineHeight: 1.05,
        letterSpacing: -0.75,
        fontSize: { xs: 28, sm: 34 },
      }}
    >
      Billing Reconciliation
    </Typography>
  </Stack>
);

export default PageHeader;
